import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'
import { EmptyState } from '@/components/ui/EmptyState'
import { formatDateTime } from '@/lib/venue/format'
import type { ReservationListItemView } from '@/lib/venue/reservationTypes'
import { RESERVATION_STATUS_TONE, bookerNameText, bookerPhoneText } from '@/lib/venue/reservationViewModel'

/** 목록 테이블 + "더 보기" 페이지네이션(설계 §2-4(2)). */
export function ReservationListTable({
  items,
  onSelect,
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
}: {
  items: ReservationListItemView[]
  onSelect: (reservationId: number) => void
  hasNextPage: boolean
  isFetchingNextPage: boolean
  onLoadMore: () => void
}) {
  if (items.length === 0) {
    return <EmptyState title="조회된 예약이 없습니다" />
  }

  return (
    <div className="space-y-3">
      <div className="overflow-x-auto rounded-xl border border-slateish-200">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="border-b border-slateish-200 bg-slateish-50 text-left text-xs font-medium text-slateish-600">
              <th className="px-3 py-2">코트</th>
              <th className="px-3 py-2">시간</th>
              <th className="px-3 py-2">예약자</th>
              <th className="px-3 py-2">연락처</th>
              <th className="px-3 py-2">상태</th>
              <th className="px-3 py-2">등록일</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr
                key={item.id}
                role="button"
                tabIndex={0}
                onClick={() => {
                  onSelect(item.id)
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') onSelect(item.id)
                }}
                className="cursor-pointer border-b border-slateish-200 last:border-b-0 hover:bg-brand-50/40"
              >
                <td className="px-3 py-2">{item.courtName}</td>
                <td className="px-3 py-2">
                  {formatDateTime(item.startsAt)} ~ {formatDateTime(item.endsAt)}
                </td>
                <td className="px-3 py-2">{bookerNameText(item)}</td>
                <td className="px-3 py-2">{bookerPhoneText(item)}</td>
                <td className="px-3 py-2">
                  <Badge tone={RESERVATION_STATUS_TONE[item.status]}>{item.statusLabel}</Badge>
                </td>
                <td className="px-3 py-2">{formatDateTime(item.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {hasNextPage ? (
        <div className="flex justify-center">
          <Button variant="secondary" size="sm" disabled={isFetchingNextPage} onClick={onLoadMore}>
            {isFetchingNextPage ? '불러오는 중' : '더 보기'}
          </Button>
        </div>
      ) : null}
    </div>
  )
}
